// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingDots_loading__erfV5","blink":"LoadingDots_blink__ttjbR"};